import moment from "moment";
import "moment/locale/pt";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import GenericBackdrop from "components/Backdrops/GenericBackdrop";
import GenericButton from "components/Buttons/GenericButton";
import RatingField from "components/FeedbackReportDataFields/Rating";
import TextField from "components/FeedbackReportDataFields/Text";
import { updateFeedbackReportMap } from "mappers/OpportunityMap";
import { getDataSetByNameAction } from "redux/actions/datasetsAction";
import { getFeedbackReportDetailsAction, updateFeedbackReportAction } from "redux/actions/opportunitiesAction";
import { labels } from "resources/resources";
import { FEEDBACK_REPORT_QUESTION_TYPE_KEY, FORM_FIELDS_PREFIX, OPPORTUNITY_FOLLOWUP_FEEDBACK_REPORT_STATE_KEY, UNITS } from "utils/const";
import limitaString from "utils/string_utils";

const useStylesGeneric = makeStyles(componentStylesGeneric);

function FeedbackReportModal(props) {
  const classes = useStylesGeneric();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));
  const intl = useIntl();
  const [feedbackReportData, setFeedbackReportData] = useState([]);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.white.light,
      },
    },
  }))(TableRow);

  const methods = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    props.getFeedbackReportDetails(props.feedbackReportId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {    
    feedbackReportData?.questions?.map((questions) => { 
      questions?.questionInformation.map((questionInformation) => {
        return methods.setValue(questionInformation.questionId, questionInformation.answer ?? "");
      })
      return null;
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedbackReportData]);

  useEffect(() => {
    if (
      (feedbackReportData?.length === 0 || 
      feedbackReportData?.length === undefined) &&
      props.opportunitiesState?.feedbackReportDetails_result?.questions?.length !== 0 &&
      props.opportunitiesState?.feedbackReportDetails_result?.questions?.length !== undefined
    ) {
      setStateFeedbackReportData(props.opportunitiesState?.feedbackReportDetails_result?.questions);
    }

    methods.setValue("feedbackReportCompletedHours", props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportCompletedHours ?? "")
    methods.setValue("feedbackReportCompletedHoursJustification", props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportCompletedHoursJustification ?? "")
    methods.setValue("feedbackReportRejectionMotive", props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportRejectionMotiveDescription ?? "") 
    methods.setValue("feedbackReportRejectionMotiveObservations", props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportRejectionMotiveObservations ?? "")
    methods.setValue("observations", props.opportunitiesState?.feedbackReportDetails_result?.observations ?? "")
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.opportunitiesState?.feedbackReportDetails_result]);

  const setStateFeedbackReportData = (questions) => {
    setFeedbackReportData({
      ...feedbackReportData,
      questions: questions?.map((q) => {
        return {
          ...q,
          questionInformation: q.questionInformation.map((qi) => {
            return {
              ...qi,
              questionId: FORM_FIELDS_PREFIX.FOLLOWUP_FEEDBACK_REPORT_DATA + qi.questionId,
            };
          }),
        };
      }),
    });
  };

  const onSubmit = (data) => {
    data["feedbackReportId"] = props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportId;

    const formData = updateFeedbackReportMap(data, feedbackReportData);

    props.updateFeedbackReport(
      formData,
      () => {
        props.handleClose();
        props.handleRefreshPage();
      }
    );
  };

  return (
    <Container maxWidth={false} disableGutters={isSmDown}>
      {props.opportunitiesState?.feedbackReportDetails_result?.questions?.length > 0 && (
        <Box>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <GenericBackdrop
              open={props.opportunitiesState?.getFeedbackReportDetails_loading}
            />
            <h2 style={{ textAlign: "center" }}>
              {props.isUserColective ? "Formulário de Empresa" : "Formulário de Estagiário"}
            </h2>
            <h4 style={{ textAlign: "center" }}>
              {props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportPeriodStartDate ? moment(props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportPeriodStartDate).format("DD/MM/YYYY"): ""}
              {(props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportPeriodStartDate && props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportPeriodEndDate) ? " a " : ""}
              {props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportPeriodEndDate ? moment(props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportPeriodEndDate).format("DD/MM/YYYY") : ""}
            </h4>
            
            {props.isUserColective && !props.opportunitiesState?.feedbackReportDetails_result?.isAdHoc && (
              <>
                <TableContainer style={{ marginBottom: "20px" }}>
                  <Box component={Table} alignItems="center" marginBottom="0!important">
                    <TableBody>
                      <TableRow>
                        <TableCell
                          classes={{
                            root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                          }}
                          width="100%"
                        >
                          Horas
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Box>
                </TableContainer>

                <Card>
                  <CardContent>
                    <Grid item xs={12} sm={12} md={6} className={classes.detailLabels} style={{ fontSize: ".8rem" }}>
                      <Grid container spacing={isSmDown ? 1 : 2} alignItems={isSmDown ? "flex-start" : "center"}>
                        <Grid item xs={12} sm={6}>
                          <Box style={{ paddingTop: isSmDown ? 0 : "15px" }}>
                            Horas de estágio realizadas:
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            isRequired={true}
                            isDisabled={!props.isEditable}
                            name={"feedbackReportCompletedHours"}
                            type={"number"}
                            control={methods.control}
                            setValue={methods.setValue}
                            getValues={methods.getValues}
                            errors={methods.formState.errors}
                            classes={classes}
                            theme={theme}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        isRequired={false}
                        isDisabled={!props.isEditable}
                        name={"feedbackReportCompletedHoursJustification"} 
                        label={"Justificação"}
                        labelDetails={"300 caracteres"}
                        multiline={true}
                        rows={2}
                        maxLength={300}
                        type={"text"}
                        control={methods.control}
                        setValue={methods.setValue}
                        getValues={methods.getValues}
                        errors={methods.formState.errors}
                        classes={classes}
                        theme={theme}
                      />
                    </Grid>

                    {props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportStateKeyValue === OPPORTUNITY_FOLLOWUP_FEEDBACK_REPORT_STATE_KEY.REJEITADO && (
                      <>
                        <Grid item xs={12} md={12}>
                          <TextField
                            isRequired={false}
                            isDisabled={true}
                            name={"feedbackReportRejectionMotive"} 
                            label={"Motivo de Rejeição"}
                            type={"text"}
                            control={methods.control}
                            setValue={methods.setValue}
                            getValues={methods.getValues}
                            errors={methods.formState.errors}
                            classes={classes}
                            theme={theme}
                          />
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <TextField
                            isRequired={false}
                            isDisabled={true}
                            name={"feedbackReportRejectionMotiveObservations"} 
                            label={"Observações de Rejeição"}
                            multiline={true}
                            rows={2}
                            type={"text"}
                            control={methods.control}
                            setValue={methods.setValue}
                            getValues={methods.getValues}
                            errors={methods.formState.errors}
                            classes={classes}
                            theme={theme}
                          />
                        </Grid>   
                      </>
                    )}
                    
                    {
                      props.opportunitiesState?.feedbackReportDetails_result?.feedbackReportStateKeyValue ===
                        OPPORTUNITY_FOLLOWUP_FEEDBACK_REPORT_STATE_KEY.PAGO && (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          className={classes.detailLabels}
                          style={{ fontSize: ".8rem" }}
                        >
                            <div style={{ float: "left", paddingTop: "15px", paddingRight: "15px" }}>
                              Valor transferido da bolsa de estÃ¡gio:
                            </div>
                            <FormGroup>
                              <OutlinedInput
                                disabled={true}
                                readOnly={true}
                                fullWidth
                                value={intl.formatNumber(props.opportunitiesState?.feedbackReportDetails_result?.amountPaid)}
                                classes={{ input: classes.monetaryFields }}
                                endAdornment={
                                  <InputAdornment disableTypography={true} position="end">
                                    {UNITS.MONETARY}
                                  </InputAdornment>
                                }
                                type="text"
                              />
                            </FormGroup>
                        </Grid>
                      )}
                  </CardContent>
                </Card>
              </>
            )}

            {!isSmDown && (
              <TableContainer style={{ marginBottom: "20px" }}>
                <Box component={Table} alignItems="center" marginBottom="0!important">
                  <>
                    {feedbackReportData?.questions?.map((questions, key) => (
                      <TableBody key={key}>
                        <TableRow key={key}>
                          <TableCell
                            classes={{
                              root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                            }}
                            width="75%"
                          >
                            {limitaString(questions.questionArea, 100)}
                          </TableCell>
                          <TableCell
                            classes={{
                              root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                            }}
                          ></TableCell>
                        </TableRow>
                        <>
                          {questions.questionInformation?.map((questionInformation, key) => (
                            <StyledTableRow key={key}>
                              <TableCell
                                classes={{ root: classes.tableCellRoot }}
                                width="75%"
                                style={{
                                  paddingLeft: "30px",
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {questionInformation.question}
                              </TableCell>
                              <TableCell classes={{ root: classes.tableCellRoot }}>
                                {questionInformation?.questionType === FEEDBACK_REPORT_QUESTION_TYPE_KEY.STAR_CLASSIFICATION && (
                                  <RatingField
                                    isRequired={true}
                                    answerValue={questionInformation.answer}
                                    name={questionInformation.questionId}
                                    isEditable={props.isEditable}
                                    control={methods.control}
                                    setValue={methods.setValue}
                                    getValues={methods.getValues}
                                    errors={methods.formState.errors}
                                    classes={classes}
                                    theme={theme}
                                  />
                                )}
                                {questionInformation?.questionType === FEEDBACK_REPORT_QUESTION_TYPE_KEY.TEXT && (
                                  <TextField
                                    isRequired={true}
                                    isDisabled={!props.isEditable}
                                    name={questionInformation.questionId}
                                    multiline={true}
                                    rows={2}
                                    maxLength={300}
                                    type={"text"}
                                    control={methods.control}
                                    setValue={methods.setValue}
                                    getValues={methods.getValues}
                                    errors={methods.formState.errors}
                                    classes={classes}
                                    theme={theme}
                                  />
                                )}
                              </TableCell>
                            </StyledTableRow>
                          ))}
                        </>
                      </TableBody>
                    ))}
                  </>
                </Box>
              </TableContainer>
            )}

            {isSmDown && (
              <Box marginBottom={2}>
                {feedbackReportData?.questions?.map((questions, areaIndex) => (
                  <Box key={areaIndex} marginBottom={2}>
                    <Box
                      className={classes.tableCellRoot + " " + classes.tableCellRootHead}
                      style={{ padding: "12px 16px" }}
                    >
                      {limitaString(questions.questionArea, 100)}
                    </Box>

                    <Box marginTop={1}>
                      {questions.questionInformation?.map((questionInformation, questionIndex) => (
                        <Box key={questionIndex} marginBottom={2}>
                          <Box
                            className={classes.tableCellRoot}
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              marginBottom: theme.spacing(1),
                            }}
                          >
                            {questionInformation.question}
                          </Box>

                          {questionInformation?.questionType === FEEDBACK_REPORT_QUESTION_TYPE_KEY.STAR_CLASSIFICATION && (
                            <RatingField
                              isRequired={true}
                              answerValue={questionInformation.answer}
                              name={questionInformation.questionId}
                              isEditable={props.isEditable}
                              control={methods.control}
                              setValue={methods.setValue}
                              getValues={methods.getValues}
                              errors={methods.formState.errors}
                              classes={classes}
                              theme={theme}
                            />
                          )}
                          {questionInformation?.questionType === FEEDBACK_REPORT_QUESTION_TYPE_KEY.TEXT && (
                            <TextField
                              isRequired={true}
                              isDisabled={!props.isEditable}
                              name={questionInformation.questionId}
                              multiline={true}
                              rows={2}
                              maxLength={300}
                              type={"text"}
                              control={methods.control}
                              setValue={methods.setValue}
                              getValues={methods.getValues}
                              errors={methods.formState.errors}
                              classes={classes}
                              theme={theme}
                            />
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}

            <Card>
              <CardContent>
                <Grid item xs={12} md={12}>
                  <TextField
                    isRequired={false}
                    isDisabled={!props.isEditable}
                    name={"observations"} 
                    label={"Observações"}
                    labelDetails={"300 caracteres"}
                    multiline={true}
                    rows={4}
                    maxLength={300}
                    type={"text"}
                    control={methods.control}
                    setValue={methods.setValue}
                    getValues={methods.getValues}
                    errors={methods.formState.errors}
                    classes={classes}
                    theme={theme}
                  />
                </Grid>
              </CardContent>
            </Card>

            {props.isEditable && (
              <Grid container>
                <Grid item xs={12} md={6}></Grid>
                <Grid item xs={12} md={3}>
                  <FormGroup>
                    <GenericButton 
                      typeSubmit={false}
                      color="secondary"
                      size={isSmDown ? "medium" : "large"}
                      fullWidth={isSmDown}
                      onClick={props.handleClose} 
                    >
                      {intl.formatMessage(labels.Label_Button_Cancel)}
                    </GenericButton>
                  </FormGroup>
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormGroup>
                    <GenericButton
                      typeSubmit={true}
                      color="primary"
                      size={isSmDown ? "medium" : "large"}
                      fullWidth={isSmDown}
                      disabled={props?.opportunitiesState?.updateFeedbackReport_loading}
                      loading={props?.opportunitiesState?.updateFeedbackReport_loading}
                    >
                      {intl.formatMessage(labels.Label_Button_Submit)}
                    </GenericButton>
                  </FormGroup>
                </Grid>
              </Grid>
            )}
          </form>
        </Box>
      )}
    </Container>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  getFeedbackReportDetails: (feedbackReportId) => dispatch(getFeedbackReportDetailsAction(feedbackReportId)),
  getDataSetByName: (name, addEmptyField) => dispatch(getDataSetByNameAction(name, addEmptyField)),
  updateFeedbackReport: (formData, _onCloseAction) => dispatch(updateFeedbackReportAction(formData, _onCloseAction))
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackReportModal);
